<template>
  <div
    class="d-flex align-items-center justify-content-center min-vh-100"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <CContainer fluid>
      <ToastContainer :toasts="toasts" />
      <CRow class="justify-content-center">
        <CCol md="6" lg="5">
          <CCard class="mx-4 mb-0 text-center">
            <CCardBody class="p-5">
              <!-- Success Icon -->
              <div class="mb-4">
                <CIcon
                  name="cil-check-circle"
                  size="4xl"
                  class="mb-2 text-marketing-accent"
                />
              </div>

              <!-- Main Message -->
              <h1 class="h4 mb-3 font-weight-bold">
                Welcome to Niagaku!
              </h1>
              <p class="text-muted mb-2">
                Your account is ready.
              </p>
              <p class="text-muted mb-4">
                We've sent a verification link to your email address.
                <strong>Please check your inbox in the next 5 minutes</strong> and click the link to activate your account.
              </p>

              <!-- Email Tips -->
              <div class="alert alert-info mb-4 text-left">
                <strong>Can't find the email?</strong>
                <ul class="mb-0 mt-2 pl-4 small">
                  <li>Check your spam or junk folder</li>
                  <li>Make sure you entered the correct email</li>
                  <li>Add noreply@niagaku.com to your contacts</li>
                  <li>Wait a few minutes and refresh your inbox</li>
                </ul>
              </div>

              <!-- Email Input for Resending Verification -->
              <CRow>
                <CCol>
                  <CInput
                    label="Email"
                    type="email"
                    autocomplete="email"
                    prepend="@"
                    v-model="email"
                    class="mb-3 border-marketing-primary text-left"
                    :disabled="loading"
                    :is-valid="!isValidEmail && email.length > 0 ? false : null"
                    invalid-feedback="Enter an email like name@company.com"
                    @input="validateEmail"
                  />
                </CCol>
              </CRow>
              <CRow
                ><CCol>
                  <!-- Call to Action Buttons -->
                  <CButton
                    class="mb-3 btn-resend btn-marketing-accent"
                    :disabled="loading || !isValidEmail"
                    @click.prevent="resendVerification"
                  >
                    <CSpinner v-if="loading" size="sm" /> Resend verification
                    email
                  </CButton>
                  <CButton
                    color="primary"
                    class="mb-3 ml-2"
                    variant="outline"
                    @click="navigateToLogin"
                  >
                    Go to log in
                  </CButton>
                </CCol></CRow
              >
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import ToastContainer from "@/views/widgets/ToastContainer.vue";

export default {
  name: "RegisterCompleted",
  components: {
    ToastContainer,
  },
  data: () => ({
    email: "", // User's email input
    toasts: [],
    loading: false, // Loading state
    isValidEmail: false,
  }),
  methods: {
    resendVerification() {
      // Check if email input is valid
      if (!this.isValidEmail) {
        this.toast("Error", "Enter your email address", "danger");
        return;
      }

      this.loading = true;
      var resendDto = {
        email: this.email,
      };

      auth
        .resendVerificationEmail(resendDto)
        .then((response) => {
          this.loading = false;
          this.toast("Info", "Verification email sent again", "info");
        })
        .catch(({ data }) => {
          this.loading = false;
          console.error(data);
          this.toast("Error", "Couldn't resend the email. " + helper.getErrorMessage(data), "danger");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateEmail() {
      const regex = /^\S+@\S+\.\S+$/;
      this.isValidEmail = regex.test(this.email);
    },
    navigateToLogin() {
      this.$router.push({ path: "/login" });
    },
    toast(header, message, color) {
      this.toasts.push({
        header: header,
        message: message,
        color: color,
        show: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-icon {
  margin-bottom: 1rem;
}

</style>
